import { Box } from '@mui/material'
import React from 'react'
import { Pie } from 'react-chartjs-2'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  ArcElement
} from 'chart.js'

interface ChartDataPoint {
  label: string
  value: number
}

ChartJS.register(
  CategoryScale,
  LinearScale,
  ArcElement,
  Title,
  Tooltip,
  Legend
)

const Colors = [
  '#EF9C39',
  '#DB486B',
  '#BE48DB',
  '#7870FA',
  '#4FC3F7'
]

type PieChartData = ChartDataPoint[]

interface Props {
  diameter: number
  data: PieChartData
}

const RingChart = (props: Props) => {
  const options = {
    type: 'pie',
    backgroundColor: 'rgba(0,0,0,0)',
    responsive: true,
    plugins: {
      legend: {
        display: false
      },
      title: {
        display: false,
        text: 'Sections'
      }
    }
  }

  const labels = props.data.map((dataPoint) => dataPoint.label.charAt(0))
  const datasets = props.data.map((dataPoint, index) => {
    return {
      data: [dataPoint.value, 10 - dataPoint.value],
      backgroundColor: [Colors[index % Colors.length], 'rgba(0,0,0,0.05)']
    }
  })

  const data = {
    labels: labels,
    datasets: datasets
  }

  return (
    <Box sx={{
      width: props.diameter,
      height: props.diameter
    }}>
      <Pie data={data} options={options} />
    </Box>
  )
}

export default RingChart
